import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-end"
}

import Thumbnail from '@/components/Common/ImagethumbnailDisplay.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';
import { firstFile } from '@/services/functions';


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleVerifyImage',
  props: {
    modelValue: {},
    form: {},
    modelId: {},
    errors: {},
    isInstallationOffice: { type: Boolean }
  },
  emits: ['update:modelValue', 'removeImage'],
  setup(__props: any, { emit: __emit }) {


const props = __props;


const emit = __emit;
  const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_file_input, {
      label: _unref(i18n).global.t('pages.vehicles.form.vehicleVerifyImage'),
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      "truncate-length": "15",
      "error-messages": __props.errors.img,
      disabled: __props.isInstallationOffice
    }, null, 8, ["label", "modelValue", "error-messages", "disabled"]),
    (
      (__props.form.vehicle_verify_image && __props.form.vehicle_verify_image.length) ||
      _unref(firstFile)(modelValue.value)
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Thumbnail, {
            image: __props.form.vehicle_verify_image,
            newImage: modelValue.value,
            modelName: "vehicles",
            modelId: props.modelId
          }, null, 8, ["image", "newImage", "modelId"]),
          _createVNode(_component_v_btn, {
            class: "exec-btn bg-danger text-white delete-btn",
            onClick: _cache[1] || (_cache[1] = () => emit('removeImage'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.form.removeImage')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})